import { Badge2 } from "@/ui2/atoms/Badge";
import { isUserPCP } from "@/redux/actions/auth";

import { getMultipleReports } from "../helpers";

import { SingleReport } from "./SingleReport";

export function MultipleReports({ renderMetaAndDownloadButton, renderViewButton, reports, type }) {
  const a5Reports = getMultipleReports(reports, type);

  if (a5Reports.length === 0) a5Reports.push(null);

  return a5Reports.map((report, i) => {
    const showMostRecentBadge = i === 0 && a5Reports.length > 1;

    return (
      <A5Report
        isAccessible={!(isUserPCP() && type === "A5-R")}
        key={`${type}-report-${i}`}
        renderMetaAndDownloadButton={renderMetaAndDownloadButton}
        renderViewButton={renderViewButton}
        report={report}
        showMostRecentBadge={showMostRecentBadge}
        type={type}
      />
    );
  });
}

function A5Report({
  isAccessible,
  renderMetaAndDownloadButton,
  renderViewButton,
  report,
  showMostRecentBadge,
  type,
}) {
  const mostRecentBadge = showMostRecentBadge ? (
    <Badge2 variant="success">Most Recent</Badge2>
  ) : null;

  return (
    <SingleReport
      badges={mostRecentBadge}
      customButton={report && isAccessible ? renderViewButton(report) : <></>}
      id={type}
      isAccessible={isAccessible}
      isEnabled={report !== null}
      metaData={report ? renderMetaAndDownloadButton(report, isAccessible) : null}
      title={`${type} Report`}
    />
  );
}
